export const OPTIONS = {
  maxSizeMB: 0.76,
  useWebWorker: true,
};
